import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Menu from "@mui/material/Menu";
import OutlinedInput from "@mui/material/OutlinedInput";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import { styled as styling } from "@mui/material/styles";
import withTheme from "@mui/styles/withTheme";
import styled from "styled-components";
import Color from "../../../assets/colors";

export const Wrapper = styling(Grid)((props) => ({
  width: "100%",
  height: "100%",
  margin: "auto",
  minHeight: "150px",
  backgroundColor: "white",
  padding: "20px 3% 20px 3%",
  // boxShadow:
  //   "0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%)",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    gap: "0px",
    padding: "5% 0 5% 0",
    minHeight: "0px",
    padding: "25px 0 25px 0",
  },
}));

export const CheckBoxStyled = styling(Checkbox)({});

export const TextFieldStyled = styling(TextField)({
  borderRadius: "16px",

  "& .MuiInput-input": {
    height: "40px",
  },

  "& .MuiFormLabel-root": {
    position: "absolute",
    top: "-7px",
  },
});

export const AutocompleteStyled = styling(Autocomplete)((props) => ({
  width: "19%",
  borderRadius: "16px",

  "& .MuiInputBase-root": {
    height: "40px",
  },

  "& .MuiInputBase-input": {
    height: "10px",
  },

  [props.theme.breakpoints.down("lg")]: {
    width: "80%",
    maxWidth: "450px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "95%",
    maxWidth: "600px",
  },
}));

export const CheckBoxOutlineBlankIconStyled = styling(CheckBoxOutlineBlankIcon)(
  {}
);

export const CheckBoxIconStyled = styling(CheckBoxIcon)({});

export const SearchIconStyled = styling(SearchIcon)({});

export const ButtonStyled = styling(Button)((props) => ({
  width: "180px",
  borderRadius: "8px",
  textTransform: "none",
  backgroundColor: "black",
  boxShadow: "none",

  ":hover": {
    backgroundColor: "black",
    color: "white",
  },

  [props.theme.breakpoints.down("lg")]: {
    borderRadius: "6px",
  },
}));

export const FilterButtonStyled = styling(Button)((props) => ({
  width: "160px",
  borderRadius: "6px",
  textTransform: "none",
  backgroundColor: props.solid ? "black" : "white",
  border: props.solid ? "" : "0.5px solid black",
  color: props.solid ? "white" : "black",

  ":disabled": {
    color: props.solid ? "white" : "",
    backgroundColor: props.solid ? Color.grey : "white",
  },

  ":hover": {
    backgroundColor: props.solid ? "#000000" : "white",
    boxShadow: `4px 4px 6px rgba(0, 0, 0, 0.2)`,
    border: props.solid ? "" : "0.5px solid black",
  },
}));

export const EmptyContainer = styling(Grid)({});

export const FormControlStyled = styling(FormControl)((props) => ({
  width: "70%",
  maxWidth: "450px",

  [props.theme.breakpoints.down("lg")]: {
    // width: "auto",
    flexGrow: 1,
    width: "30%",
    maxWidth: "600px",
  },
}));

export const FormControlSalaryStyled = styling(FormControl)((props) => ({
  width: "19%",

  [props.theme.breakpoints.down("lg")]: {
    width: "80%",
    maxWidth: "450px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "95%",
    maxWidth: "600px",
  },
}));

export const RadioStyled = styling(Radio)((props) => ({}));

export const RadioGroupStyled = styling(RadioGroup)((props) => ({}));

export const FormControlLabelStyled = styling(FormControlLabel)((props) => ({
  height: "5px",
}));

export const RadioLabelStyled = styling(FormControlLabel)((props) => ({}));

export const FormLabelStyled = styling(FormLabel)((props) => ({}));

export const OutlinedInputStyled = styling(OutlinedInput)((props) => ({
  height: "40px",
}));

export const InputAdornmentStyled = styling(InputAdornment)({});

export const IconButtonStyled = styling(IconButton)({});

export const ChipStyled = styling(Chip)({
  color: Color.darkGrey,
  borderRadius: "4px",
  height: "30px",
  marginBottom: "10px",
});

export const MenuStyled = styling(Menu)({});

export const SelectStyled = styling(Select)({
  width: "100%",
  height: "40px",
});

export const SliderStyled = styling(Slider)({});

export const TextFieldSalaryStyled = styling(TextField)((props) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },

  "& .MuiFormLabel-root": {
    position: "absolute",
    top: "-7px",
    color: props.disabled ? "rgb(214, 214, 214)" : "rgb(162, 162, 162)",
  },
}));

export const InnerSalaryStyled = styling(TextField)({
  "& .MuiInputBase-root": {
    height: "40px",
  },
  marginBottom: "10px",
});

export const ChipWrapper = withTheme(styled.div`
&& {
  gap: 10px;
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
  display: flex;

    /* ScrollBar */
    &::-webkit-scrollbar {
      height: 5px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #f1f1f1; 
      border-radius: 100px;
    }
  
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: ${Color.darkGrey}; 
      border-radius: 100px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555; 
    }
    }
}`);
